import React from 'react';
import {
  ButtonContainer,
  // Container,
  ParentContainer,
  TextContainer,
  // Wrapper,
} from './table-pagination.styled';
import { PaginationLeftArrow } from '../../../../icons/pagination-left-arrow';
import { Text } from '../../../../../style-utils/text';
import { PaginationRightArrow } from '../../../../icons/pagination-right-arrow';
import { palette } from '../../../../../style-utils/theme';

interface PaginationButtons {
  currentPage: number;
  hasPreviousPage: boolean | null;
  hasNextPage: boolean | null;
  previousPage: () => void;
  nextPage: () => void;
  totalPages: number | null;
}

export const PaginationButtons: React.FC<PaginationButtons> = ({
  hasNextPage,
  hasPreviousPage,
  currentPage,
  previousPage,
  nextPage,
  totalPages,
}) => {
  return (
    <ParentContainer>
      <ButtonContainer
        type="button"
        aria-label="Previous page"
        disabled={!hasPreviousPage}
        onClick={previousPage}
      >
        <PaginationLeftArrow
          color={hasPreviousPage ? palette.ink : palette.slateLight}
        />
      </ButtonContainer>

      {/* "1 of 0" IS NOT A PAGE NUMBER. QA-05, 2026-08-27.
          An empty result gives totalPages === 0 (Math.ceil(0 / n)) while
          currentPage is still its initial 1, and this rendered the pair
          verbatim. Reported against Users; the same component also serves
          Buildings, Staff Access and Records, so it was on four screens.
          Nothing is paginated when there is nothing to page through, so the
          indicator is omitted rather than made to read "0 of 0" — a counter for
          an empty list is noise next to the empty state that already says so.
          The arrows stay, disabled, so the control does not jump around. */}
      {(totalPages || 0) > 0 && (
        <TextContainer>
          <Text>
            {/* Clamped as well as gated: a mutation that shortens the list can
                leave currentPage past the end for the render before the reset
                effect fires, which showed "3 of 2". */}
            {Math.min(currentPage, totalPages || 1)} of {totalPages}
          </Text>
        </TextContainer>
      )}

      <ButtonContainer
        type="button"
        aria-label="Next page"
        disabled={!hasNextPage}
        onClick={nextPage}
      >
        <PaginationRightArrow
          color={hasNextPage ? palette.ink : palette.slateLight}
        />
      </ButtonContainer>
    </ParentContainer>
  );
};
